import { useTranslation } from 'react-i18next';
import Page from '@/components/Page';

const Disclosure = () => {
  const { t } = useTranslation();

  return (
    <Page
      title={t('pages.disclosure.title')}
    >
      <Page.Section>{t('pages.disclosure.content')}</Page.Section>
    </Page>
  );
};

export default Disclosure;
